export enum StatisticValueStatusEnum {
    OK = 'ok',
    WARNING = 'warning',
    CRITICAL = 'critical',
}
